<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      app
      class="drawer"
      disable-resize-watcher
    >
      <v-row>
        <v-col class="col-12 text-center mt-5">
          <!-- Logo goes here -->
          <img
            v-if="agencyView == true"
            :src="agency.agencyLogo"
            width="200px"
          />
          <img
            v-else
            src="../../assets/Compeat-logo.jpg"
            width="200px"
            max-height="100px"
          />
        </v-col>
        <v-col>
          <v-list class="py-0">
            <v-list-item-group>
              <v-list-item
                v-if="this.$store.state.loggedIntoFacebook"
                @click="menuActionClick('dashboard')"
                dense
              >
                <v-list-item-icon color="primary">
                  <v-icon color="primary">mdi-view-dashboard</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-if="superAdmin" class="primary--text"
                    >Dashboard</v-list-item-title
                  >
                  <v-list-item-title v-else class="primary--text"
                    >Dashboard Overview</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-group
                :value="false"
                dense
                v-if="
                  (this.$store.state.user.userType == 'SMM' &&
                    this.$store.state.loggedIntoFacebook) ||
                  (this.$store.state.user.userType == 'AA' &&
                    this.$store.state.loggedIntoFacebook) ||
                  (this.$store.state.user.userType == 'RS' &&
                    this.$store.state.loggedIntoFacebook)
                "
              >
                <template v-slot:activator>
                  <v-list-item-icon color="primary">
                    <v-icon color="primary">mdi-apps</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title class="primary--text"
                    >CompEat</v-list-item-title
                  >
                </template>

                <v-list-item
                  v-if="
                    (this.$store.state.user.userType == 'SMM' &&
                      this.$store.state.loggedIntoFacebook) ||
                    (this.$store.state.user.userType == 'AA' &&
                      this.$store.state.loggedIntoFacebook)
                  "
                  @click="menuActionClick('agencySubscriptions')"
                  dense
                >
                  <v-list-item-icon>
                    <v-icon color="primary">mdi-layers</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="primary--text"
                      >Subscriptions</v-list-item-title
                    >
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  v-if="
                    this.$store.state.user.userType == 'RS' &&
                    this.$store.state.loggedIntoFacebook
                  "
                  @click="menuActionClick('resellerSubscriptions')"
                  dense
                >
                  <v-list-item-icon>
                    <v-icon color="primary">mdi-layers</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="primary--text"
                      >Subscriptions</v-list-item-title
                    >
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  v-if="
                    (this.$store.state.user.userType == 'SMM' &&
                      this.$store.state.loggedIntoFacebook) ||
                    (this.$store.state.user.userType == 'AA' &&
                      this.$store.state.loggedIntoFacebook) ||
                    (this.$store.state.user.userType == 'RS' &&
                      this.$store.state.loggedIntoFacebook)
                  "
                  @click="menuActionClick('agencyCancelledSubscriptions')"
                  dense
                >
                  <v-list-item-icon>
                    <v-icon color="primary">mdi-layers-off</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="primary--text"
                      >Cancelled Subscriptions</v-list-item-title
                    >
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  v-if="
                    (this.$store.state.user.userType == 'SMM' &&
                      this.$store.state.loggedIntoFacebook) ||
                    (this.$store.state.user.userType == 'AA' &&
                      this.$store.state.loggedIntoFacebook)
                  "
                  @click="menuActionClick('agencyDemos')"
                  dense
                >
                  <v-list-item-icon>
                    <v-icon color="primary">mdi-timer-sand</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="primary--text"
                      >Demo Subscription</v-list-item-title
                    >
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  v-if="
                    this.$store.state.user.userType == 'RS' &&
                    this.$store.state.loggedIntoFacebook
                  "
                  @click="menuActionClick('resellerDemos')"
                  dense
                >
                  <v-list-item-icon>
                    <v-icon color="primary">mdi-timer-sand</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="primary--text"
                      >Demo Subscription</v-list-item-title
                    >
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>
              <v-list-item
                v-if="superAdmin"
                @click="menuActionClick('agencies')"
                dense
              >
                <v-list-item-icon>
                  <v-icon color="primary">mdi-home-modern</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="primary--text"
                    >Agencies</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                v-if="superAdmin"
                @click="menuActionClick('subscriptions')"
                dense
              >
                <v-list-item-icon>
                  <v-icon color="primary">mdi-checkbox-multiple-blank</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="primary--text"
                    >Search Subscriptions</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                v-if="
                  superAdmin ||
                  (agencyView && this.$store.state.loggedIntoFacebook)
                "
                @click="menuActionClick('users')"
                dense
              >
                <v-list-item-icon>
                  <v-icon color="primary">mdi-account-multiple</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="primary--text"
                    >Users</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item @click="logout()" dense>
                <v-list-item-icon>
                  <v-icon color="primary">mdi-clipboard-alert</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="primary--text"
                    >Logout</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-col>
      </v-row>
    </v-navigation-drawer>
    <v-app-bar
      app
      flat
      class="primary"
      :class="{
        'instagram-toolbar-color': isCustomPage,
      }"
    >
      <v-app-bar-nav-icon
        v-if="
          agencyView == true ||
          socialMarketingManagerView == true ||
          superAdmin == true ||
          subscriber == true ||
          agencySales == true ||
          reseller == true
        "
        class="white--text"
        @click="drawer = !drawer"
      >
      </v-app-bar-nav-icon>
      <v-toolbar-title class="white--text" >CompEat</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn v-if="this.$route.name === 'createSingleSubscription'" @click="backToDashboard()" class="secondary" rounded small><v-icon>mdi-arrow-left</v-icon> Back</v-btn>
    </v-app-bar>
  </div>
</template>

<script>
import { firebaseApp } from "@/firebaseConfig";
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import { getFirestore, doc, getDoc } from "firebase/firestore";
const db = getFirestore(firebaseApp);

export default {
  data: () => ({
    drawer: false,
    agencyView: false,
    socialMarketingManagerView: false,
    superAdmin: false,
    subscriber: false,
    agencySales: false,
    reseller: false,
    agency: [],
    user: [],
  }),
  created() {
    this.getUserRole();
  },
  computed: {
    isCustomPage() {
      return this.$route.name === "instagramInsightsReport"; // Replace 'CustomPage' with the name of your specific page route
    },
  },
  methods: {
    getUserRole() {
      const auth = getAuth();
      onAuthStateChanged(auth, (user) => {
        if (user) {
          let currentSignInUser =
            user.auth.currentUser.reloadUserInfo.customAttributes;
          let currentUserRole = JSON.parse(currentSignInUser);

          if (currentUserRole.UserRole === "Agency Admin") {
            this.agencyView = true;
            this.getUserAgencyId(user.uid);
          } else if (currentUserRole.UserRole === "Social Marketing Manager") {
            this.socialMarketingManagerView = true;
            this.getUserAgencyId(user.uid);
          } else if (currentUserRole.UserRole === "Super Admin") {
            this.superAdmin = true;
          } else if (currentUserRole.UserRole === "Subscriber") {
            this.subscriber = true;
          } else if (currentUserRole.UserRole === "Agency Sales") {
            this.agencySales = true;
          } else if (currentUserRole.UserRole === "Reseller") {
            this.reseller = true;
          }
        }
      });
    },
    async getUserAgencyId(uid) {
      const docRef = doc(db, "users", uid);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        this.user = docSnap.data();
        let agencyId = this.user.agencyId;
        this.getAgencyInfo(agencyId);
      }
    },
    async getAgencyInfo(agencyId) {
      const agencyRef = doc(db, "agencies", agencyId);
      const agencyDoc = await getDoc(agencyRef);

      if (agencyDoc.exists()) {
        let agencyInfo = agencyDoc.data();
        this.agency = agencyInfo;
      }
    },
    menuActionClick(action) {
      if (action == "dashboard") {
        this.$router.push("/");
      } else if (action == "users") {
        this.$router.push("/users");
      } else if (action == "agencies") {
        this.$router.push("/agencies");
      } else if (action == "subscriptions") {
        this.$router.push("/subscriptions");
      } else if (action == "resellerSubscriptions") {
        this.$router.push("/reseller-subscriptions");
      } else if (action == "agencySubscriptions") {
        this.$router.push("/agency-subscriptions");
      } else if (action == "agencyDemos") {
        this.$router.push("/agency-demos");
      } else if (action == "resellerDemos") {
        this.$router.push("/reseller-demos");
      } else if (action == "agencyCancelledSubscriptions") {
        this.$router.push("/agency-cancelled-subscriptions");
      }
    },
    backToDashboard(){
      if(this.$store.state.user.userType == "AA" || this.$store.state.user.userType == "SMM") {
        this.$router.push("/agency-subscriptions");
      }else {
        this.$router.push("/");
      }
    },
    logout() {
      const auth = getAuth(firebaseApp);
      signOut(auth)
        .then(() => {
          this.$store.commit("logout");
          this.$router.replace("/login");
        })
        .catch((error) => {
          alert(error);
        });
    },
  },
};
</script>

<style>
.instagram-toolbar-color {
  background: radial-gradient(
    circle at 30% 107%,
    #fdf497 0%,
    #fdf497 5%,
    #fd5949 45%,
    #d6249f 60%,
    #285aeb 90%
  );
}
</style>
